module.exports = __webpack_public_path__ + "img/404.5879ac88.svg";